"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _JobOffersCard = _interopRequireDefault(require("./JobOffersCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _JobOffersCard.default;
exports.default = _default;